import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { FilePreview } from "@/components/FilePreview";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function FileUploader({ files, setFiles, testId = "file-uploader", label = "Unggah foto/video", accept = "image/*,video/*" }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handleChange = async (e) => {
    const selected = Array.from(e.target.files || []);
    if (!selected.length) return;
    setUploading(true);
    const uploaded = [];
    const ALLOWED = ["jpg", "jpeg", "png", "webp", "gif", "pdf", "mp4", "mov", "webm", "avi"];
    for (const f of selected) {
      const ext = f.name.split(".").pop()?.toLowerCase();
      const isVideo = ["mp4", "mov", "webm", "avi"].includes(ext);
      const limitMb = isVideo ? 50 : 10;
      if (!ALLOWED.includes(ext)) {
        toast.error(`Tipe file .${ext} tidak diizinkan.`);
        continue;
      }
      if (f.size > limitMb * 1024 * 1024) {
        toast.error(`${f.name} melebihi batas ${limitMb} MB.`);
        continue;
      }
      const form = new FormData();
      form.append("file", f);
      try {
        const { data } = await api.post("/upload", form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        uploaded.push(data);
      } catch (e) {
        toast.error(e.response?.data?.detail || `Gagal mengunggah ${f.name}`);
      }
    }
    setFiles([...(files || []), ...uploaded]);
    setUploading(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  const remove = (file) => setFiles(files.filter((f) => f.id !== file.id));

  return (
    <div>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple
        className="hidden"
        onChange={handleChange}
        data-testid={`${testId}-input`}
      />
      <div className="flex flex-wrap gap-2">
        {(files || []).map((f) => (
          <FilePreview key={f.id} file={f} onRemove={remove} />
        ))}
        <button
          type="button"
          data-testid={`${testId}-btn`}
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="flex h-24 w-24 flex-col items-center justify-center gap-1 rounded-md border-2 border-dashed border-slate-300 text-slate-400 hover:border-[#0047AB] hover:text-[#0047AB]"
        >
          {uploading ? (
            <Loader2 className="h-5 w-5 animate-spin" />
          ) : (
            <Upload className="h-5 w-5" />
          )}
          <span className="text-[10px]">{label}</span>
        </button>
      </div>
    </div>
  );
}
